import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_PngMaker = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/png-maker',
			name: 'PNG Maker – Delete PNG Background Online | Lift',
			description:
				'Remove PNG background instantly with AI. No watermark. Convert JPG to PNG, remove backgrounds, compress & create transparent PNGs in seconds. Try now!',
			url: 'https://liftapp.ai/png-maker',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/png-maker#product' },
				{ '@id': 'https://liftapp.ai/png-maker#howto' },
				{ '@id': 'https://liftapp.ai/png-maker#benefits' },
				{ '@id': 'https://liftapp.ai/png-maker#faq' },
				{ '@id': 'https://liftapp.ai/png-maker#why-lift' },
				{ '@id': 'https://liftapp.ai/png-maker#explore-tools' },
				{ '@id': 'https://liftapp.ai/png-maker#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/png-maker#product',
			name: 'PNG Background Remover',
			description:
				'Remove PNG background in seconds with our AI PNG maker. Remove backgrounds, convert JPG to PNG, and edit images online, no watermarks.',
			url: 'https://liftapp.ai/png-maker',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/png-maker#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let the AI do the work',
					text: 'Watch as Lift removes the background PNG automatically',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/png-maker#benefits',
			name: 'Who Benefits from Our PNG Maker?',
			description:
				"Lift's AI PNG Maker is useful for professionals, creators, and businesses who want clean, transparent PNG images for e-commerce, social media, marketing, or personal use.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: '**E-commerce Sellers** — Create professional product PNGs with transparent backgrounds for Amazon, Etsy, or your online store. Process up to 20 images at once to build your catalog faster and boost conversions',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: '**Content Creators** — Make eye-catching thumbnails, Instagram posts, and TikTok content. Cut out objects, create collages, and design unique visuals without expensive software — perfect for YouTube covers and social media graphics',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: '**Designers & Freelancers** — Speed up your workflow with instant background removal and PNG conversion. Deliver professional cutouts to clients faster, reduce manual editing time, and take on more projects',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: '**Small Business Owners** — Design marketing materials, event posters, presentations, and ads with clean transparent backgrounds. No designer needed — create professional visuals in minutes',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: '**Students & educators** — PNGs for school projects, presentations, and creative assignments. Remove PNG backgrounds to create professional-looking posters, reports, and digital portfolios.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'PNG Maker Use Cases',
				description:
					'Example of how Lift AI PNG Maker creates transparent PNG images for various use cases.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/png-maker#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI PNG Maker?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift PNG Maker is a online tool that creates transparent PNG images with AI-powered background removal. Convert JPG to PNG, remove backgrounds, compress images, and process up to 20 photos at once — no software installation or watermarks required.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI PNG Maker work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Simply upload your image (JPG, JPEG, or PNG) to Lift. Our AI automatically detects the subject, removes the background, and converts it to a transparent PNG in seconds. You can batch process up to 20 images simultaneously for faster workflow.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI PNG Maker uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking cutouts without manual touch-ups.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/png-maker#why-lift',
			name: "Why Lift's AI PNG Maker stands out",
			description:
				"Lift's PNG Maker combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Remove PNG background',
				description:
					"Comparison of Lift's AI PNG Maker benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/png-maker#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/png-maker#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'PNG Maker',
					item: 'https://liftapp.ai/png-maker',
				},
			],
		},
	],
};
